import React from 'react'

import { ZariContext } from '_zari/context'
import { Button, Modal, Row, Col } from '_zari/core'

import { RounderUtil } from 'utils'

import * as FormGroups from './formGroups'
import * as Sections from './sections'

import * as ProductoService from 'services/producto.service'
import * as InventarioService from 'services/inventario.service'
import * as TablaPersonalizadaService from 'services/tablasPersonalizadas.service'

const AsignarPrecioModal = ({ handleClose, show, modalData }) => {
  const __zariContext = React.useContext(ZariContext)

  const [listaPrecios, setListasPrecios] = React.useState([])
  const [infoCostosProducto, setInfoCostosProducto] = React.useState(null)

  React.useEffect(() => {
    TablaPersonalizadaService.obtenerEstructuraPrecios()
      .then(({ data }) => {
        const infoPrecios = data.map(({ _id, ...x }) => ({
          ...x,
          _idPrecioxLista: _id
        }))

        ProductoService.obtenerPreciosxIdPresentacion(modalData._id)
          .then(({ data: data2 }) => {
            const infoPreciosCompleto = infoPrecios.map(x => {
              const matchExistente = data2.find(
                y => y._idListaPrecio === x._idListaPrecio && y._idPrecioxLista === x._idPrecioxLista
              )

              return {
                ...x,
                ...matchExistente
              }
            })

            setListasPrecios(infoPreciosCompleto)
          })
          .catch(({ data: { error } }) => __zariContext.snack('error', error))
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext, modalData._id])

  React.useEffect(() => {
    __zariContext.loader.open('Obteniendo costos del producto.')
    InventarioService.obtenerInfoCostosxIdProducto(modalData._idProducto)
      .then(({ data }) => {
        if (data) {
          if (data.afectacion === '10') {
            data.costoReposicion = RounderUtil.round(data.costoReposicion * 1.18, 2)
            data.costoPromedio = RounderUtil.round(data.costoPromedio * 1.18, 4)
          }
          setInfoCostosProducto(data)
        }
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext, modalData._idProducto])

  return (
    <Modal show={show} onHide={handleClose} size='lg'>
      <Modal.Header>
        <Modal.Title>MANTENIMIENTO PRECIOS</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {infoCostosProducto && (
          <>
            <Row>
              <Col md={3}>
                <FormGroups.CodigoFormGroup iValue={modalData.codigo} />
              </Col>
              <Col md={6}>
                <FormGroups.NombreFormGroup iValue={modalData.nombre} />
              </Col>
              <Col md={3}>
                <FormGroups.MonedaFormGroup iValue={modalData.moneda} />
              </Col>
            </Row>
            <Row className='mb-3'>
              <Col md={3}>
                <FormGroups.CostoReposicionFormGroup iValue={infoCostosProducto.costoReposicion} />
              </Col>
              <Col md={3}>
                <FormGroups.CostoPromedioFormGroup iValue={infoCostosProducto.costoPromedio} />
              </Col>
            </Row>
            {listaPrecios.map((x, k) => (
              <Sections.EdicionPrecioSection key={k} info={x} infoCostosProducto={infoCostosProducto} />
            ))}
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(AsignarPrecioModal)
